import styled from 'styled-components';

export const StyledPtwDashboard = styled.div`
  display: flex;
  gap: 20px;
  color: var(--color-text-main);
  width: 100%;
  height: 100%;

  .layout-main {
    flex: 1 1;
    display: flex;
    flex-direction: row;
    padding: 20px 20px 20px 20px;
    gap: 20px;
    width: 100%;
    height: 100%;
    min-height: max-content;
  }

  .layout-left {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    gap: 20px;
    min-height: max-content;
  }

  .layout-left .map {
    flex: 1 1;
    padding: 10px;
    background-color: #ffffff;
    box-shadow: 0px 0px 6px 0px #00000026;
    border-radius: 10px;
    position: relative;
  }

  .layout-left .risk-alert {
    flex: 0 0;
    gap: 20px;
  }

  .layout-right {
    display: flex;
    flex-direction: column;
    flex: 0 0;
    gap: 20px;
    min-height: max-content;
  }

  .arrow-box {
    background-color: #ffffff;
    box-shadow: 0px 0px 1px 0px #00000029;
    cursor: pointer;
  }

  .arrow-box.arrow-right {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    right: -20px;
    transform: translate(-50%, -50%);
    height: 32px;
    width: 16px;
  }

  .arrow-box.arrow-bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 32px;
    height: 16px;
  }

  .arrow-box img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
`;

interface StyledTimelineProps {
  $isCollapsed: boolean;
}

export const StyledTimeline = styled.div<StyledTimelineProps>`
  position: absolute;
  bottom: 15px;
  left: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.15);
  z-index: 10;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 내부 컨텐츠가 넘치지 않도록 */
  border: 1px solid rgba(255, 255, 255, 0.3);

  .timeline-header {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    cursor: pointer;
    background: rgba(248, 249, 250, 0.6);
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    user-select: none;

    &:hover {
      background: rgba(241, 243, 245, 0.8);
    }

    span {
      font-size: 13px;
      font-weight: 600;
      color: #495057;
    }

    .toggle-icon {
      font-size: 12px;
      color: #868e96;
      transition: transform 0.3s;
    }
  }

  /* 컨텐츠 영역: $isCollapsed 상태에 따라 높이 조절 */
  .timeline-content-wrapper {
    transition:
      max-height 0.3s ease-in-out,
      opacity 0.2s;
    max-height: ${(props) => (props.$isCollapsed ? '0px' : '200px')};
    opacity: ${(props) => (props.$isCollapsed ? '0' : '1')};
    overflow: hidden;
  }

  .timeline-content {
    display: flex;
    flex-direction: row;
    gap: 12px;
    padding: 16px;
    overflow-x: auto;

    &::-webkit-scrollbar {
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: #dee2e6;
      border-radius: 3px;
    }
  }
`;

export const SnapshotCard = styled.div<{ $active: boolean }>`
  min-width: 140px;
  cursor: pointer;
  border: 2px solid ${(props) => (props.$active ? '#055cb4' : 'rgba(255, 255, 255, 0.2)')};
  border-radius: 6px;
  overflow: hidden;
  background: ${(props) =>
    props.$active ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.6)'};
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-4px);
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    border-color: ${(props) => (props.$active ? '#055cb4' : 'rgba(255, 255, 255, 0.5)')};
  }

  .thumb {
    width: 100%;
    height: 80px;
    object-fit: cover;
    background: #e9ecef;
    opacity: 0.9;
  }

  &:hover .thumb {
    opacity: 1;
  }

  .info {
    padding: 8px;
    background: transparent;

    .date {
      font-size: 12px;
      font-weight: 700;
      color: ${(props) => (props.$active ? '#055cb4' : '#495057')};
    }
    .desc {
      font-size: 11px;
      color: #6c757d;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 2px;
    }
  }
`;
